import React from 'react';

import { STAFF_USERS_LIST_QUERY_KEY, UsersListPage } from '../../shared/users';

export const StaffUsersList: React.FC = () => (
  <UsersListPage
    queryKeyBase={STAFF_USERS_LIST_QUERY_KEY}
    displayTypePrefKey="StaffUsers"
    pendingInvitationsRoute="/staff/pending-invitations"
    showOrganization={true}
    showOrganizationFilter={true}
    linkContext="staff"
  />
);
